// typesac.jsx
import React from "react";
import "../css/typeac.css";

// Import images from src/assets so bundlers include them
import repair8 from "../assets/repair8.jpg";
import repair9 from "../assets/repair9.jpg";
import repair10 from "../assets/repair10.jpg";


const types = [
  {
    id: 8,
    img: repair8,
    title: "Split AC Repair Service",
    desc: "Reliable split AC repair service for efficient cooling solutions.",
  },
  {
    id: 9,
    img: repair9,
    title: "Window AC Repair Service",
    desc: "Fast and affordable window AC repair for optimal performance.",
  },
  {
    id: 10,
    img: repair10,
    title: "Cassette AC Repair Service",
    desc: "Expert cassette AC repair ensuring efficient cooling and comfort.",
  },
 
];

export default function TypesAC() {
  const phoneDisplay = "72378 98275";
  const telHref = "tel:7237898275";

  return (
    <section className="types-ac-section" aria-labelledby="types-ac-heading">
      <div className="types-ac-container">
        <h2 id="types-ac-heading" className="types-ac-title">Types of AC We Serve!</h2>
        <p className="types-ac-sub">
          We repair and service split AC, window AC, cassette AC, duct AC, and central AC.
        </p>

        <div className="types-grid" role="list">
          {types.map((t) => (
            <article className="type-card" key={t.id} role="listitem" tabIndex="0">
              <div className="type-image" aria-hidden="false">
                <img src={t.img} alt={t.title} loading="lazy" />
              </div>

              <div className="type-body">
                <h3 className="type-title">{t.title}</h3>
                <p className="type-desc">{t.desc}</p>
                <a className="type-phone" href={telHref} aria-label={`Call ${phoneDisplay}`}>
                  CALL US {phoneDisplay}
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
